import React from "react";
import "./Product.css";

const products = [
  {
    id: 1,
    name: "Bộ phát wifi Netgear Nighthawk X6S R8000P - Tri-band AC4000",
    image: "/product/1.jpg",
    price: "3.490.000 đ",
    oldPrice: "5.600.000 đ",
    discount: "-38%",
  },
  {
    id: 2,
    name: "Router Wifi Huawei AX3 Pro WS7200 - WiFi 6, tốc độ 2976Mbps",
    image: "product/2.jpg",
    price: "1.690.000 đ",
    oldPrice: "",
    discount: "",
  },
  {
    id: 3,
    name: "Router WiFi Linksys EA8100-AH - Băng tần kép chuẩn AC Wave2",
    image: "product/3.jpg",
    price: "1.960.000 đ",
    oldPrice: "2.908.000 đ",
    discount: "-33%",
  },
  {
    id: 4,
    name: "Wifi Router R8000 NetGear NightHawk X6 Tri-band AC3200",
    image: "product/4.jpg",
    price: "2.060.000 đ",
    oldPrice: "6.900.000 đ",
    discount: "-71%",
  },
  {
    id: 5,
    name: "Netgear Orbi Tri-band Mesh WiFi Satellite RBS20, chuẩn AC2200",
    image: "product/5.jpg",
    price: "1.780.000 đ",
    oldPrice: "3.910.000 đ",
    discount: "-55%",
  },
  {
    id: 6,
    name: "Netgear Orbi Tri-band Mesh WiFi Satellite RBS50, chuẩn AC3000",
    image: "product/6.jpg",
    price: "4.400.000 đ",
    oldPrice: "4.990.000 đ",
    discount: "-12%",
  },
  {
    id: 7,
    name: "Bộ phát wifi APTEK A122e. Hai băng tần chuẩn AC1200",
    image: "product/7.jpg",
    price: "550.000 đ",
    oldPrice: "699.000 đ",
    discount: "-22%",
  },
  {
    id: 8,
    name: "Tenda Nova MW6 (pack 3), hệ thống ghép nối nhiều router",
    image: "product/8.jpg",
    price: "2.085.000 đ",
    oldPrice: "3.190.000 đ",
    discount: "-35%",
  },
  {
    id: 9,
    name: "Router WiFi 6 băng tần kép tốc độ cao cho gia đình",
    image: "product/9.jpg",
    price: "1.250.000 đ",
    oldPrice: "1.590.000 đ",
    discount: "-21%",
  },
  {
    id: 10,
    name: "Bộ phát mesh wifi phủ sóng văn phòng 2 tầng",
    image: "product/10.jpg",
    price: "2.890.000 đ",
    oldPrice: "3.590.000 đ",
    discount: "-19%",
  },
  {
    id: 11,
    name: "Router game thủ chuẩn AX5400, hiệu suất mạnh",
    image: "product/11.jpg",
    price: "3.990.000 đ",
    oldPrice: "4.490.000 đ",
    discount: "-11%",
  },
  {
    id: 12,
    name: "Router WiFi chuẩn AC1200 giá tốt cho nhà phố",
    image: "product/12.jpg",
    price: "690.000 đ",
    oldPrice: "850.000 đ",
    discount: "-18%",
  },
  {
    id: 13,
    name: "Mesh WiFi mini tốc độ cao phù hợp căn hộ",
    image: "product/13.jpg",
    price: "1.980.000 đ",
    oldPrice: "2.490.000 đ",
    discount: "-20%",
  },
  {
    id: 14,
    name: "Router WiFi 6 antenna ngoài, phủ sóng rộng",
    image: "product/14.jpg",
    price: "1.390.000 đ",
    oldPrice: "1.790.000 đ",
    discount: "-22%",
  },
  {
    id: 15,
    name: "Thiết bị phát WiFi văn phòng nhỏ 20-30 user",
    image: "product/15.jpg",
    price: "1.150.000 đ",
    oldPrice: "",
    discount: "",
  },
  {
    id: 16,
    name: "Router hiệu năng cao hỗ trợ IPTV và gaming",
    image: "product/16.jpg",
    price: "2.250.000 đ",
    oldPrice: "2.750.000 đ",
    discount: "-18%",
  }
];

const sortOptions = [
  "Mới nhất",
  "Giá tăng dần",
  "Giá giảm dần",
  "Lượt xem",
  "Đánh giá",
  "Tên A->Z",
];

function CartIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="20" r="1.5" />
      <circle cx="18" cy="20" r="1.5" />
      <path d="M3 4h2l2.2 10.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H7" />
    </svg>
  );
}

function GridIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
      <rect x="3" y="3" width="7" height="7" rx="1.2" />
      <rect x="14" y="3" width="7" height="7" rx="1.2" />
      <rect x="3" y="14" width="7" height="7" rx="1.2" />
      <rect x="14" y="14" width="7" height="7" rx="1.2" />
    </svg>
  );
}

function ListIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
      <rect x="4" y="5" width="4" height="4" rx="1" />
      <rect x="10" y="5.5" width="10" height="3" rx="1" />
      <rect x="4" y="15" width="4" height="4" rx="1" />
      <rect x="10" y="15.5" width="10" height="3" rx="1" />
    </svg>
  );
}

function ProductCard({ product }) {
  return (
    <div className="product-card">
      <a href="/" className="product-thumb">
        <img src={product.image} alt={product.name} />
      </a>

      <h3 className="product-title">
        <a href="/">{product.name}</a>
      </h3>

      <div className="product-price">{product.price}</div>

      <div className="product-bottom">
        <div className="product-meta">
          {product.oldPrice && (
            <span className="old-price">{product.oldPrice}</span>
          )}
          {product.discount && (
            <span className="discount-badge">{product.discount}</span>
          )}
        </div>

        <button className="cart-btn" aria-label="Thêm vào giỏ hàng">
          <CartIcon />
        </button>
      </div>
    </div>
  );
}

export default function Product() {
  return (
    <section className="product-section">
      <div className="toolbar">
        <div className="toolbar-left">
          <span className="sort-label">Sắp xếp theo</span>
          <div className="sort-list">
            {sortOptions.map((item, index) => (
              <button
                key={item}
                className={`sort-btn ${index === 0 ? "active" : ""}`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="toolbar-right">
          <button className="view-btn" aria-label="Xem dạng lưới">
            <GridIcon />
          </button>
          <button className="view-btn" aria-label="Xem dạng danh sách">
            <ListIcon />
          </button>
        </div>
      </div>

      <div className="product-grid">
        {products.slice(0, 20).map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
}